import React from 'react'
import { string, object, func } from 'prop-types'

import Input from 'coact/Input'

function CopySetting (props) {
  const { value, onChange, copyRange, style } = props
  return (
    <div>
      <div style={{ width: 150, display: 'inline-block', verticalAlign: 'middle' }}>
        <Input {...{ value, onChange }} />
      </div>
      <div className={style.setting} onClick={copyRange}>
        複製
      </div>
    </div>
  )
}
CopySetting.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
  copyRange: func.isRequired,
  style: object.isRequired,
}

export default CopySetting



// WEBPACK FOOTER //
// ./src/components/RangeEditor/CopySetting/CopySetting.jsx